import { useEffect } from "react";

interface UseKeyboardOptions {
  enabled?: boolean;
  preventDefault?: boolean;
}

export const useKeyboard = (
  key: string,
  callback: () => void,
  options: UseKeyboardOptions = {},
) => {
  const { enabled = true, preventDefault = true } = options;

  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      const isCtrl = event.ctrlKey;
      if (!key.toLowerCase().includes("ctrl") && isCtrl) {
        return;
      }

      if (event.key.toLowerCase() === key.toLowerCase()) {
        if (preventDefault) {
          event.preventDefault();
        }
        callback();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [key, callback, enabled, preventDefault]);
};
